<template>
  <div id="app">
    <input
      type="text"
      placeholder="Location..."
      @keyup.enter="
        getData();
        showForecast();
      "
    />

    <div class="error" v-if="error === true">
      Your input is wrong. Please try again.
    </div>

    <div v-else>
      <div class="weather_infos" v-if="typeof result.main != 'undefined'">
        <p class="date">
          {{ date.getDate() }}.{{ date.getMonth() + 1 }}.{{
            date.getFullYear()
          }}
        </p>
        <h1>{{ result.name }} ({{ result.sys.country }})</h1>
        <h2>{{ result.weather[0].main }}</h2>
        <div class="icon-weather" v-if="result.weather[0].main === 'Clouds'">
          <img src="./assets/img/wolke.png" alt="" />
        </div>
        <div class="icon-weather" v-if="result.weather[0].main === 'Rain'">
          <img src="./assets/img/regen.png" alt="" />
        </div>
        <div class="icon-weather" v-if="result.weather[0].main === 'Clear'">
          <img src="./assets/img/wolkig.png" alt="" />
        </div>
        <p class="temp">{{ Math.round(result.main.temp) }} °C</p>
        <p>Wind: {{ Math.round(result.wind.speed * 3.6) }} km/h</p>
        <div class="wind-animation">
          <img class="wind-icon" src="./assets/img/wind.png" alt="" />
          <img src="./assets/img/windmill.png" alt="" />
        </div>
        <!--<img class="sun-icon" src="./assets/img/sun.png" alt="">
      <p>Sunrise: {{ sunrise.getHours() }}:{{ sunrise.getMinutes() }}</p>
      <img class="sun-icon" src="./assets/img/moon.png" alt="">
      <p>Sunset: {{ sunset.getHours() }}:{{ sunset.getMinutes() }}</p>-->
      </div>

      <div class="forecast" v-if="myDates.length > 0">
        <p>
          {{ myDates[0].getDate() }}.{{ myDates[0].getMonth() + 1 }}.{{
            myDates[0].getFullYear()
          }}
        </p>
        <p>{{ Math.round(myTempMin[0]) }}° / {{ Math.round(myTempMax[0]) }}°</p>
        <p>
          {{ myDates[1].getDate() }}.{{ myDates[1].getMonth() + 1 }}.{{
            myDates[1].getFullYear()
          }}
        </p>
        <p>{{ Math.round(myTempMin[1]) }}° / {{ Math.round(myTempMax[1]) }}°</p>
        <p>
          {{ myDates[2].getDate() }}.{{ myDates[2].getMonth() + 1 }}.{{
            myDates[2].getFullYear()
          }}
        </p>
        <p>{{ Math.round(myTempMin[2]) }}° / {{ Math.round(myTempMax[2]) }}°</p>
        <p>
          {{ myDates[3].getDate() }}.{{ myDates[3].getMonth() + 1 }}.{{
            myDates[3].getFullYear()
          }}
        </p>
        <p>{{ Math.round(myTempMin[3]) }}° / {{ Math.round(myTempMax[3]) }}°</p>
        <p>
          {{ myDates[4].getDate() }}.{{ myDates[4].getMonth() + 1 }}.{{
            myDates[4].getFullYear()
          }}
        </p>
        <p>{{ Math.round(myTempMin[4]) }}° / {{ Math.round(myTempMax[4]) }}°</p>
      </div>
    </div>
    <br />

    <footer class="footer">
      Icons:
      <a href="https://www.flaticon.com/de/autoren/linector" title="Linector"
        >Linector</a
      >
      from
      <a href="https://www.flaticon.com/de/" title="Flaticon"
        >www.flaticon.com</a
      >
    </footer>
  </div>
</template>

<script>
import key from "./config/configs";
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      myAPI: key.apiKEY,
      apiUrl: "https://api.openweathermap.org/data/2.5/weather?q=",
      forecastUrl: "https://api.openweathermap.org/data/2.5/forecast?q=",
      q: this.inputVal,
      result: {},
      date: "",
      forecast: [],
      myDates: [],
      myTempMin: [],
      myTempMax: [],
      error: false,
      //sunrise: "",
      //sunset: "",
    };
  },
  components: {},
  methods: {
    getData() {
      let inputVal = document.querySelector("input").value;
      axios
        .get(this.apiUrl + inputVal + "&units=metric&appid=" + this.myAPI)
        .then((res) => {
       
          this.result = res.data;

          let datetime = res.data.dt;

          this.date = new Date(datetime * 1000);

          this.myDates = [];
          this.myTempMin = [];
          this.myTempMax = [];
          this.error = false;
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response);
          } else if (err.request) {
            console.log("no response found");
          } else {
            console.log(err);
            this.error = true;
          }
          this.error = true;
        });
    },

    showForecast() {
      let inputVal = document.querySelector("input").value;
      axios
        .get(this.forecastUrl + inputVal + "&units=metric&appid=" + this.myAPI)
        .then((res) => {
          this.forecast = res.data;
          //let myDatesList = "";
          for (let x = 0; x < this.forecast.list.length; x += 8) {
            //myDatesList = res.data.list[i];
            let dates = new Date(this.forecast.list[x].dt * 1000);
            this.myDates.push(dates);
            this.myTempMin.push(this.forecast.list[x].main.temp_min);
            this.myTempMax.push(this.forecast.list[x].main.temp_max);
          }
          this.error = false;
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response);
          } else if (err.request) {
            console.log("no response found");
          } else {
            console.log(err);
            this.error = true;
          }
          this.error = true;
        });
    },
  },
};
</script>

<style>
body {
  width: 100%;
  margin: 0 auto;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #212e3b;
  margin: 0 auto;
  position: relative;
  overflow: auto;
  max-width: 500px;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("./assets/img/blue-sky.jpg");
}

input {
  margin-top: 34px;
  width: 60%;
  padding: 12px;
  border: none;
  border-bottom: 2px solid #2c3e50;
  font-size: 20px;
  outline: none;
}

input::placeholder {
  font-size: 20px;
  color: #2c3e508e;
  overflow: visible;
}

.date {
  background: rgba(173, 216, 230, 0.76);
  max-width: 100px;
  padding: 4px;
  border-radius: 6px;
  margin: 0 auto;
  font-weight: bold;
}

.weather_infos {
  margin-top: 24px;
}

img {
  width: 60px;
  height: auto;
}

h1 {
  margin-top: 10px;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes wind {
  from {
    transform: translate(-15px, 0);
    opacity: 1;
  }
  to {
    transform: translate(85px, 0);
    opacity: 0.15;
  }
}

.wind-icon {
  animation: wind 2.5s ease-in-out infinite;
}

.sun-icon {
  animation: rotate 4s linear infinite;
}

h2 {
  margin: 0;
}
.icon-weather {
  width: 100px;
  margin: 0 auto;
  padding: 10px;
  transform-origin: 50% 0;
  animation: icon 1.5s ease-in-out infinite alternate;
}

@keyframes icon {
  0% {
    transform: translate(0, 0);
    transform: rotate(5deg);
  }
  100% {
    transform: translate(2.5px, 0);
    transform: rotate(-5deg);
  }
}

.temp {
  font-size: 24px;
  padding: 6px;
  background: rgba(255, 255, 255, 0.322);
  border-radius: 10px;
  max-width: 100px;
  margin: 2% auto;
}
p {
  margin: 0;
  margin-bottom: 14px;
  font-weight: 600;
}
.forecast > p {
  display: inline-block;
  width: 50%;
}
.footer {
  position: fixed;
  bottom: 0;
  padding: 6px;
  text-align: center;
  font-size: 12px;
  opacity: 0.75;
}
.footer > a {
  text-decoration: none;
  color: #2c3e50;
}
.error {
  font-size: 20px;
  margin: 0 auto;
  margin-top: 44px;
  color: rgb(238, 223, 223);
  background: rgba(255, 0, 0, 0.596);
  border-radius: 12px;
  width: 70%;
  padding: 6px;
  animation: err 0.25s ease-in;
}
@keyframes err {
  0% {
    transform: translate(6px);
  }
  25% {
    transform: translate(-6px);
  }
  75% {
    transform: translate(6px);
  }
  100% {
    transform: translate(-6px);
  }
}
</style>
